module.exports = function(app) {
    app.directive('equalToValidator', function () {
        return {
            restrict: "A",
            require: "ngModel",
            scope: {
                equalTo: '=equalToValidator'
            },
            link: function (scope, element, attrs, ctrl) {

                scope.$watch('equalTo', function () {
                    ctrl.$validate();
                });

                ctrl.$validators.equalToValidator = function (modelValue, viewValue) {
                    return viewValue === scope.equalTo;
                };
            }
        };
    });
}